import Vue from 'vue';
import router from '@app/plugins/vue-router';
import vbclass from 'vue-body-class';

Vue.use(vbclass, router);
